var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDViewMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3417969,10.5800781L26.2363281,2.5273438c-1.3994141-0.6992188-3.0712891-0.6992188-4.4726562,0L5.6582031,10.5800781 C4.6357422,11.0917969,4,12.1201172,4,13.2636719v21.5c0,1.1435547,0.6357422,2.171875,1.6582031,2.6835938l16.1054688,8.0253906 c0.7011719,0.3496094,1.46875,0.5244141,2.2373047,0.5244141c0.7666016,0,1.5341797-0.1738281,2.2314453-0.5224609 l16.109375-8.0273438C43.3642578,36.9355469,44,35.9072266,44,34.7636719v-21.5 C44,12.1201172,43.3642578,11.0917969,42.3417969,10.5800781z M22.6582031,4.3164062 C23.078125,4.1064453,23.5390625,4.0019531,24,4.0019531s0.921875,0.1044922,1.3417969,0.3144531l15.3945312,7.6972656 L24,20.3818359L7.2636719,12.0136719L22.6582031,4.3164062z M6.5527344,35.6582031C6.2119141,35.4882812,6,35.1455078,6,34.7636719 V13.6181641l17,8.5v21.6881104c-0.1156616-0.0408325-0.2347412-0.0692139-0.3457031-0.1246338L6.5527344,35.6582031z  M41.4472656,35.6582031l-16.1054688,8.0253906C25.2322388,43.7382812,25.1143188,43.7661743,25,43.8066406V22.1181641l17-8.5 v21.1455078C42,35.1455078,41.7880859,35.4882812,41.4472656,35.6582031z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDViewMedium);
export default __webpack_public_path__ + "static/media/three-d-view--medium.5c5dd6b5d9a1f3741117f07137a74862.svg";
export { ForwardRef as ReactComponent };